<div class="side-modal-container" [ngClass]="{'side-modal-open': open}">
  @if (showClose) {
    <div class="close icon-close" (click)="close()"></div>
  }
  <ng-content></ng-content>
</div>

